import { ActionReducer, ActionReducerMap, MetaReducer } from '@ngrx/store';

import * as fromCmsPage from './cms-pages/cms-pages.reducer';
import * as fromPageMetas from './page-metas/page-metas.reducer';
import * as fromRouter from '@ngrx/router-store';

import { RouterEffects } from '@store/router/router effects';
import { UserEffects } from '@store/user/user.effects';

import { StoreLogger } from '@lib/utils/logger/store-logger';

import { environment } from '../../environments/environment';
import { CmsPagesEffects } from '@store/cms-pages/cms-pages.effects';
import { PageMetasEffects } from '@store/page-metas/page-metas.effects';
import { RootEffects } from '@store/root.effects';

export interface RootState {
  cmsPages: fromCmsPage.CmsPagesState;
  pageMetas: fromPageMetas.PageMetasState;
  router: fromRouter.RouterReducerState<any>;
}

export const initialState: RootState = {
  cmsPages: fromCmsPage.initialState,
  pageMetas: fromPageMetas.initialState,
  router: { navigationId: 0, state: null },
};

export const reducers: ActionReducerMap<RootState> = {
  cmsPages: fromCmsPage.reducer,
  pageMetas: fromPageMetas.reducer,
  router: fromRouter.routerReducer,
};

export function logger(reducer: ActionReducer<RootState>): any {
  return StoreLogger.logger({ collapsed: true })(reducer);
}

export const metaReducers: MetaReducer<RootState>[] = environment.production ? [] : [logger];

export const EFFECTS = [RootEffects, RouterEffects, CmsPagesEffects, UserEffects, PageMetasEffects];
